export function sortListValue<T>(list: T[], sortScheme: T[]) {
  return sortScheme.map(element => (list.includes(element) ? element : null)).filter(Boolean) as T[];
}
